import React from 'react';
import cn from 'classnames';

import { GameLogo, MarketsCount, SmartLink } from 'components';
import favorite from 'modules/favorite';
import Markets from '../Markets';
import DateTime from '../DateTime';
import useMatchRow from './useMatchRow';
import './matchRow.scss';

interface Props {
    matchId: string;
    countRenderMarkets: number;
    hasMatchHeader: boolean;
}

const {
    components: { ToggleFavoriteButton },
} = favorite;

const MatchRow: React.FC<Props> = ({
    matchId,
    countRenderMarkets,
    hasMatchHeader,
}) => {
    const { match, linkToMatch, competitors, isOddStatVisible } = useMatchRow({
        matchId,
    });

    if (!match) return null;

    const { sportId, startTime, marketsCount } = match;

    return (
        <div
            styleName={cn('container', {
                'is-one-market-view': countRenderMarkets === 1,
                'is-odd-stat-visible': isOddStatVisible,
            })}
        >
            <div styleName="favorite">
                <ToggleFavoriteButton matchId={matchId} />
            </div>

            <div styleName="logo">
                <GameLogo gameId={sportId} />
            </div>

            <div styleName="info">
                <SmartLink styleName="competitors" to={linkToMatch}>
                    <div styleName="competitor">{competitors.homeName}</div>
                    <div styleName="competitor">{competitors.awayName}</div>
                </SmartLink>

                <div styleName="date">
                    <DateTime startTime={startTime} />
                </div>
            </div>

            <div styleName="markets">
                <Markets
                    matchId={matchId}
                    hasMatchHeader={hasMatchHeader}
                    sportId={sportId}
                    count={countRenderMarkets}
                />
            </div>

            <MarketsCount
                marketsCount={marketsCount}
                topMarketsCount={countRenderMarkets}
                linkToMatch={linkToMatch}
            />
        </div>
    );
};

export default React.memo(MatchRow);
